import { useContext } from 'react';
import { ExternalLink } from 'lucide-react';
import AppContext from 'contexts/AppContext';
import { getJiraIssueUrl } from 'utils/jiraUrls';

/** A ticket key in mono, opening the ticket in Jira in a new tab. */
const TicketKeyLink = ({ issueKey }: { issueKey: string }) => {
  const { jiraBrowseBase } = useContext(AppContext);
  return (
    <a
      href={getJiraIssueUrl(issueKey, jiraBrowseBase)}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 font-mono text-[12.5px] font-medium underline decoration-zinc-300 underline-offset-[3px] dark:decoration-zinc-700"
    >
      {issueKey}
      <ExternalLink className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
    </a>
  );
};

export default TicketKeyLink;
